import React, { useEffect, useRef, useState } from "react";
import useStyles from "../styles";
import { Grid, Paper } from "@material-ui/core";
import { Doughnut } from "react-chartjs-2";
import {
  doughnutData1,
  doughnutDataCampaignPerformance,
  doughnutDataLoyaltyCustomers,
  options
} from "../utils/graphs";

const LoyaltyPieChart = ({ jwt }) => {
  const chart1 = useRef(null);
  const chart2 = useRef(null);
  const [legend1, setLegend1] = useState([]);
  const [legend2, setLegend2] = useState([]);

  const {
    dashboardSection,
    doughnutTitle,
    legendStyle,
    bigTitle,
    paperRoot,
    secondLegendBullet,
    firstLegendBullet,
    thirdLegendBullet
  } = useStyles();

  useEffect(() => {
    setLegend1(chart1.current.props.data.labels);
    setLegend2(chart2.current.props.data.labels);
  }, []);

  const male = 103;
  const female = 200;
  const totalLoyaltyCustomers = male + female;

  const clicked = 103;
  const opened = 103;
  const purchased = 103;
  const totalCampaignPerformance = clicked + opened + purchased;

  return (
    <Grid container className={dashboardSection}>
      <Grid item xs={6}>
        <Paper elevation={0} className={paperRoot}>
          <div className={doughnutTitle}>Total Loyalty Customers </div>
          <div className={bigTitle}>{totalLoyaltyCustomers}</div>
          <div style={{ height: "300px", marginBottom: "30px" }}>
            <Doughnut
              ref={chart1}
              data={doughnutDataLoyaltyCustomers({
                male,
                female
              })}
              options={options}
            />
          </div>
          <div>
            <ul className="chart-ul">
              {legend1 &&
                legend1.map((item, i) => {
                  return (
                    <div key={item} className={legendStyle}>
                      <div
                        className={
                          i === 0 ? firstLegendBullet : secondLegendBullet || 0
                        }
                      />
                      <span>{item} </span>
                      <span>
                        {i === 0
                          ? `${Math.round(
                              (male / totalLoyaltyCustomers) * 100
                            )}%` || 0
                          : `${Math.round(
                              (female / totalLoyaltyCustomers) * 100
                            )}%` || 0}
                      </span>
                    </div>
                  );
                })}
            </ul>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={0} className={paperRoot}>
          <div className={doughnutTitle}>Total Loyalty Customers </div>
          <div className={bigTitle}>{totalCampaignPerformance}</div>
          <div style={{ height: "300px", marginBottom: "30px" }}>
            <Doughnut
              ref={chart2}
              data={doughnutDataCampaignPerformance({
                clicked,
                opened,
                purchased
              })}
              options={options}
            />
          </div>
          <div>
            <ul className="chart-ul">
              {legend2 &&
                legend2.map((item, i) => {
                  return (
                    <div key={item} className={legendStyle}>
                      <div
                        className={
                          i === 0
                            ? firstLegendBullet
                            : i === 1
                            ? secondLegendBullet
                            : thirdLegendBullet || 0
                        }
                      />
                      <span>{item} </span>
                      <span>
                        {i === 0
                          ? `${Math.round(
                              (clicked / totalCampaignPerformance) * 100
                            )}%` || 0
                          : i === 1
                          ? `${Math.round(
                              (opened / totalCampaignPerformance) * 100
                            )}%` || 0
                          : `${Math.round(
                              (purchased / totalCampaignPerformance) * 100
                            )}%` || 0}
                      </span>
                    </div>
                  );
                })}
            </ul>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default LoyaltyPieChart;
